/**
 * Shared Checkbox Component
 * 
 * A reusable, accessible checkbox component with support for labels and descriptions.
 * Styled with Tailwind CSS, Storybook compliant.
 */
import { FC, ReactNode, ReactElement, ChangeEvent } from 'react';

interface CheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string | ReactNode;
  id?: string;
  name?: string;
  disabled?: boolean;
  variant?: 'default' | 'with-label';
  className?: string;
}

const Checkbox: FC<CheckboxProps> = ({
  checked = false,
  onChange,
  label,
  id,
  name,
  disabled = false,
  variant: _variant = 'default',
  className = '',
}): ReactElement => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <label className={`flex items-start gap-2 ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}>
      <input
        id={id}
        name={name}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className="w-4 h-4 mt-[3px] accent-black rounded border-gray-300 cursor-pointer focus:outline-none flex-shrink-0"
      />
      {label && (
        <span>
          {label}
        </span>
      )}
    </label>
  );
};

export default Checkbox;
